import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

export const NfcIcon = ({ className = "" }) => (
  <svg viewBox="0 0 120 70" className={className} fill="none" stroke="#0B1120" strokeWidth="3" strokeLinecap="round">
    <ellipse cx="40" cy="35" rx="36" ry="29" />
    <path d="M30 25a14 14 0 0 1 0 20M38 20a22 22 0 0 1 0 30M46 15a30 30 0 0 1 0 40" />
    <rect x="78" y="6" width="28" height="52" rx="6" fill="#A8DCF2" />
    <path d="M88 12h8" />
  </svg>
);

const Stars = ({ className = "w-4 h-4" }) => (
  <div className="flex gap-1.5 justify-center">
    {[0, 1, 2, 3, 4].map((i) => (
      <svg key={i} viewBox="0 0 24 24" className={className} fill="#fff"><path d="M12 2l2.9 6.3 6.9.7-5.2 4.6 1.5 6.8L12 17l-6.1 3.4 1.5-6.8L2.2 9l6.9-.7z" /></svg>
    ))}
  </div>
);

export const StandFace = ({ compact = false }) => (
  <div className="relative h-full w-full rounded-[22px] overflow-hidden bg-gradient-to-br from-[#C4E8F8] via-[#A8DCF2] to-[#8FD0EE] border border-white/70 shadow-[inset_0_1px_0_rgba(255,255,255,0.9)] flex flex-col items-center px-[9%] pt-[16%] pb-[16%]">
    <div className="absolute -top-1/3 -left-1/4 w-2/3 h-[160%] rotate-[24deg] bg-gradient-to-r from-white/0 via-white/45 to-white/0 pointer-events-none" />
    <div className="w-full rounded-md bg-[#0B1120] ring-2 ring-[#0B1120] outline outline-1 outline-white/60 outline-offset-[-5px] py-[5%] px-2">
      <Stars className={compact ? "w-2.5 h-2.5" : "w-4 h-4 sm:w-5 sm:h-5"} />
      <p className={`mt-1 text-center text-white font-bold uppercase tracking-tight leading-none ${compact ? "text-[7px]" : "text-[11px] sm:text-sm"}`} style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}>
        Please leave us a review
      </p>
    </div>
    <p className={`mt-auto italic font-semibold text-[#0B1120] ${compact ? "text-[8px]" : "text-sm sm:text-base"}`}>Tap your phone here</p>
    <div className="relative mt-[6%] w-[70%]">
      <span className="nfc-ring absolute left-[8%] top-[4%] w-[55%] aspect-square rounded-full border-2 border-white/80" />
      <span className="nfc-ring absolute left-[8%] top-[4%] w-[55%] aspect-square rounded-full border-2 border-white/80" style={{ animationDelay: "1.2s" }} />
      <NfcIcon className="relative w-full" />
    </div>
  </div>
);

export const Stand3D = () => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rY = useSpring(useTransform(mx, [-0.5, 0.5], [-18, 18]), { stiffness: 120, damping: 18 });
  const rX = useSpring(useTransform(my, [-0.5, 0.5], [12, -6]), { stiffness: 120, damping: 18 });

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const reset = () => { mx.set(0); my.set(0); };

  return (
    <div data-testid="hero-nfc-stand-interactive" onMouseMove={onMove} onMouseLeave={reset} className="relative w-full flex items-center justify-center py-6" style={{ perspective: 1200 }}>
      <motion.div style={{ rotateX: rX, rotateY: rY, transformStyle: "preserve-3d" }} className="relative w-[240px] sm:w-[300px] lg:w-[340px]">
        <motion.div
          animate={{ y: [0, -10, 0] }}
          transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
          style={{ transformStyle: "preserve-3d" }}
        >
          <div className="aspect-[3/4] [transform:rotateX(6deg)] origin-bottom shadow-[0_40px_80px_-30px_rgba(31,111,153,0.55)] rounded-[22px]">
            <StandFace />
          </div>
          <div className="mx-auto -mt-1 h-16 w-[104%] -translate-x-[2%] rounded-b-[22px] bg-gradient-to-b from-[#9ED6EF] to-[#C9EBF9] border border-white/70 [transform:rotateX(78deg)] origin-top" />
        </motion.div>
        <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 w-[90%] h-8 rounded-[50%] bg-[#1F6F99]/25 blur-2xl" />
      </motion.div>
    </div>
  );
};
